// extracted by mini-css-extract-plugin
export default {"familyView":"FamilyView_familyView__HyRna"};